import styled from 'styled-components'
import { getSize } from 'utils'
import { theme } from 'styles/theme'
import BaseLayout from '../components/BaseLayout'
import { Description } from '../components/BaseLayout/styled'

export const StyledLayoutLight = styled(BaseLayout)`
  .cloud {
    left: 45.8%;
    display: flex;
    position: relative;
    transform: rotate(-90deg);
    height: 100%;
  }

  ${Description} {
    left: ${getSize(100)};
    color: ${theme.colors.cloudPurple};
    background-color: ${theme.colors.white};
    font-size: ${getSize(42)};
    line-height: ${getSize(58)};
    font-family: 'Poppins';
    font-weight: 400;

    @media (max-aspect-ratio: 1/1) {
      left: ${getSize(50)};
    }
  }
`
export const StyledLayoutDark = styled(BaseLayout)`
  .cloud {
    right: 45.8%;
    position: absolute;
    transform: rotate(90deg);
    height: 100%;
  }
  ${Description} {
    right: ${getSize(100)};
    color: ${theme.colors.white};
    background-color: ${theme.colors.cloudPurple};
    font-size: ${getSize(42)};
    line-height: ${getSize(58)};
    font-family: 'Poppins';
    font-weight: 400;
    @media (max-aspect-ratio: 1/1) {
      right: ${getSize(50)};
    }
  }
`
